<section
  class="unauthorized-page"
  role="alert"
  aria-labelledby="unauthorized-title"
>
  <div class="unauthorized-content">
    <article class="unauthorized-card">
      <div class="status-bar"></div>

      <div class="card-body">
        <div class="icon-wrapper" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 9V13"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            />

            <path
              d="M12 16.01L12.01 15.9989"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
            />

            <path
              d="M10.29 3.86L1.82 18
                 C1.65 18.30 1.55 18.65 1.55 18.99
                 C1.55 19.34 1.64 19.69 1.81 19.99
                 C1.99 20.29 2.24 20.55 2.54 20.72
                 C2.84 20.90 3.18 21 3.53 21
                 H20.47
                 C20.82 21 21.16 20.90 21.46 20.72
                 C21.76 20.55 22.01 20.29 22.19 19.99
                 C22.36 19.69 22.45 19.34 22.45 18.99
                 C22.45 18.65 22.35 18.30 22.18 18
                 L13.71 3.86
                 C13.53 3.57 13.28 3.32 12.98 3.15
                 C12.68 2.99 12.34 2.90 12 2.90
                 C11.66 2.90 11.32 2.99 11.02 3.15
                 C10.72 3.32 10.47 3.57 10.29 3.86Z"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <span class="error-code"> ERROR 403 </span>

        <h1 id="unauthorized-title">Acceso no autorizado</h1>

        <p class="description">
          No cuentas con los permisos necesarios para acceder a esta sección de
          ZIVO ERP.
        </p>

        <p class="help-text">
          Si consideras que deberías tener acceso, comunícate con tu
          administrador o con el equipo de TI.
        </p>

        <div class="divider"></div>

        <div class="actions">
          <button
            type="button"
            class="btn btn-primary"
            (click)="volverInicio()"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M3 11.5L12 4L21 11.5"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M5.5 10V20H18.5V10"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linejoin="round"
              />

              <path
                d="M9.5 20V14H14.5V20"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linejoin="round"
              />
            </svg>

            Ir al inicio
          </button>

          <button
            type="button"
            class="btn btn-secondary"
            (click)="volverAtras()"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            Volver atrás
          </button>
        </div>
      </div>
    </article>

    <footer class="unauthorized-footer">
      <span>© {{ anioActual }} NOVAX</span>

      <span class="footer-dot"></span>

      <span>ZIVO ERP</span>

      <span class="footer-dot"></span>

      <span>Departamento de TI</span>
    </footer>
  </div>
</section>
